import { mount } from 'svelte'
import Index from '@/components/keywords/Index.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('keywords-index-app')
  if (el) {
    mount(
      Index,
      {
        target: el,
        props: {
          shortCode: el.dataset.shortCode,
          initialKeywords: el.dataset.keywords
        },
      })
  }
})
